<template>
  <div>
    <a href="#" @click.prevent="dialog = true"><v-icon color="primary">mdi-information</v-icon> What does Third party Only Cover?</a>
    <v-dialog
        v-model="dialog"
        width="500"
    >
      <v-card class="tw-px-2">
        <card-title>Third Party Only Cover</card-title>
        <v-card-text class="tw-mt-5">
          Third Party is the minimum insurance cover plan that every car owner must have to be legally on the road. The cover protects the insured’s from any Liability wherever they may be legally liable to pay in the event of an accident. It covers Bodily injury, Property damage and Theft cover as a result of your vehicle being stolen.
          <br>
          This cover does not protect the car owner from personal liabilities - any repair costs are met by the insured himself.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';

export default {
  name: 'WhatIsThirdParty',
  components: { CardTitle },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
